// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/scss/default.scss'
import locale from 'element-ui/lib/locale/lang/en'
import '../src/font/font.css'
import '../src/common/default.scss'
import format from '../src/utils/format'
import Utils from './utils/utils.js'
window.Utils = Utils;

Vue.config.productionTip = false
Vue.use(ElementUI, {locale})
Vue.prototype.$box = format

router.beforeEach((to, from, next) => {
  let token = window.sessionStorage.getItem('token');
  let path = to.path;
  if (path == '/login') {
      next();
      return;
  }
  if (token) {
      next();
  } else {
      next({
          path: '/login'
      })
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js